export default {
  depositFrom: 'החל מתאריך לעמלות נפרעים',
  depositUntil: 'תוקף לעמלות נפרעים',
  accumulationFrom: 'החל מתאריך לעמלות היקף',
  accumulationUntil: 'תוקף לעמלות היקף',
  number: 'מספר הסכם',
  agent: 'מספר סוכן',
  company: 'חברה מנהלת',
  branch: 'מוצר',
  branches: 'מוצרים',
  accordType: 'סוג הסכם',
  accordName: 'שם הסכם',
  comments: 'הערות',
  submit: 'עדכן',
  commision: {
    agentFeeMonthlyDeposit: 'עמלת סוכן נפרעים מהפקדה %',
    agentFeeMonthlyAccumulation: 'עמלת סוכן נפרעים מצבירה %',
    agentFeeAnnualAccumulation: 'עמלת סוכן היקף מצבירה %',
    agentFeeAnnualDeposit: 'עמלת סוכן היקף מהפקדה %',
    employeeAgentCommission: 'עמלת סוכן שכיר %',
  },
};
